// Generated by GitHub Copilot

import { useState } from "react";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Alert from "react-bootstrap/Alert";
import Badge from "react-bootstrap/Badge";
import { FaUser, FaCog, FaInfoCircle } from "react-icons/fa";
import ProfileFeatureManager from "./ProfileFeatureManager";
import RefreshIndicator from "../Modern/Incidents/components/RefreshIndicator";
import { capitalize } from "../../utils/textFormatters";

import "./Profile.css";
// Generated by GitHub Copilot
// import LeftNavigation from "../LeftNavigation/LeftNavigation";

function Profile(props) {
  const user = props.user;
  const [refreshState, setRefreshState] = useState({ refreshing: false, lastUpdated: null });

  const privilegeMarkup =
    user &&
    user.privileges &&
    Object.keys(user.privileges).map((p) => {
      if (user.privileges[p] === true) {
        return (
          <Badge key={p} bg="primary" className="me-1 mb-1">
            {capitalize(p)}
          </Badge>
        );
      }
      return undefined;
    });

  // Generated by GitHub Copilot
  // Updated for US1717644 "Even Muggles Get Toggles" - all authenticated users can manage feature flags
  // No longer requiring edit privileges for self-service feature flag management
  const canManageFeatureFlags = !!user; // Any authenticated user can manage their own feature flags

  return (
    <Container className="profile-container py-4" fluid>
      <div className="profile-content">
        {/* Profile Information Section */}
        <Card className="mb-4">
                <Card.Header className="profile-card-header d-flex align-items-center">
                  <FaUser className="me-2" />
                  <h5 className="mb-0">Profile Information</h5>
                </Card.Header>
                <Card.Body>
                  <div className="profile-info-list">
                    <div className="profile-info-item">
                      <div className="profile-info-label">Name</div>
                      <div className="profile-info-value">{user.name}</div>
                    </div>

                    <div className="profile-info-item">
                      <div className="profile-info-label">Email</div>
                      <div className="profile-info-value">{user.email}</div>
                    </div>

                    <div className="profile-info-item">
                      <div className="profile-info-label">Privileges</div>
                      <div className="profile-info-value">
                        {privilegeMarkup && privilegeMarkup.length > 0 ? (
                          privilegeMarkup
                        ) : (
                          <Badge bg="secondary">None</Badge>
                        )}
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>

        {/* Feature Flag Management Section */}
        <Card>
                <Card.Header className="profile-card-header d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <FaCog className="me-2" />
                    <h5 className="mb-0">Feature Flag Management</h5>
                  </div>
                  {canManageFeatureFlags && (
                    <RefreshIndicator
                      isRefreshing={refreshState.refreshing}
                      lastUpdated={refreshState.lastUpdated}
                      showTimestamp={!refreshState.refreshing && !!refreshState.lastUpdated}
                    />
                  )}
                </Card.Header>
                <Card.Body>
                  {canManageFeatureFlags ? (
                    <ProfileFeatureManager
                      user={user}
                      onRefreshStateChange={setRefreshState}
                    />
                  ) : (
                    <Alert
                      variant="info"
                      className="mb-0 d-flex align-items-center"
                    >
                      <FaInfoCircle className="me-2" />
                      <div>
                        <strong>
                          Feature flag management is not available.
                        </strong>
                        <br />
                        <small>
                          Please log in to manage your feature flags.
                        </small>
                      </div>
                    </Alert>
                  )}
                </Card.Body>
              </Card>
      </div>
    </Container>
  );
}

export default Profile;
